<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>Rediger anlæg</h1>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>

<div mat-dialog-content>
  <form [formGroup]="anlaegForm" autocomplete="off">
    <div class="form-row margin-bottom-x2">
      @if (fabrikater) {
        <app-fabrikat-input
          appearance="outline"
          showLabel="false"
          [form]="anlaegForm"
          [fabrikater]="fabrikater"
          [selectFabrikat$]="selectedFabrikat$"
          (fabrikatChange)="onFabrikatChange($event)"
        ></app-fabrikat-input>
      }
      @if (fabrikater && fabrikatWarning) {
        <div>
          <em>Du skal sikre dig OK fra relevant servicechef og s-partner, før du opretter serviceaftale på dette fabrikat.</em>
        </div>
      }
    </div>

    <div class="form-row margin-bottom-x2">
      <app-model-input
        appearance="outline"
        showLabel="false"
        [form]="anlaegForm"
        [modeller]="modeller"
        [selectModel$]="selectedModel$"
        (modelChange)="onModelChange($event)"
      ></app-model-input>
      @if (modeller && modelWarning) {
        <div>
          <em>Du skal sikre dig OK fra relevant servicechef og s-partner, før du opretter serviceaftale på dette fabrikat.</em>
        </div>
      }
    </div>

    <div class="form-row">
      @if (installatoerer && canWrite) {
        <app-installatoer-input
          appearance="outline"
          showLabel="false"
          [form]="anlaegForm"
          [installatoerer]="installatoerer"
          (installatoerChange)="onInstallatoerChange($event)"
        ></app-installatoer-input>
      }
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Installationsdato</mat-label>
        <mat-datepicker-toggle matPrefix [for]="installationDatePicker"></mat-datepicker-toggle>
        <input
          #installationDateInput
          matInput
          [matDatepicker]="installationDatePicker"
          formControlName="installationDate"
          min="1900-01-01"
          />
          <mat-datepicker #installationDatePicker></mat-datepicker>
        </mat-form-field>
      </div>

      @if (hasOlderKomponenter) {
        <div>
          Denne installationsdato for anlægget er nyere end mindst en komponent på anlægget. Et anlæg kan ikke være nyere end dets bestanddele.
          Hvis du går videre sættes alle ældre datoer til den ny installationsdato.
        </div>
      }

      <div class="form-row">
        <mat-form-field appearance="outline">
          <mat-label>Serienummer</mat-label>
          <input formControlName="serienummer" matInput />
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field appearance="outline">
          <mat-label>Garantiperiode</mat-label>
          <input type="number" formControlName="garantiPeriode" matInput />
          <span matSuffix>måneder</span>
        </mat-form-field>
      </div>
      <div class="form-row">
        <mat-form-field appearance="outline">
          <mat-label>Effekt</mat-label>
          <input formControlName="effekt" matInput />
          <span matSuffix>kW</span>
          @if (effekt.hasError('pattern')) {
            <mat-error>Min/Max værdier = x-y. F.eks. 100-200</mat-error>
          }
          @if (effekt.hasError('minmax')) {
            <mat-error>Maksimum effekt skal være større end minimum effekt.</mat-error>
          }
          @if (effekt.hasError('produkt')) {
            <mat-error>Minimum og maksimum effekt ikke tilladt for varmepumper.</mat-error>
          }
        </mat-form-field>
      </div>

      @if (product.text != 'Varmepumpe') {
        <div>
          <div class="form-row">
            <mat-slide-toggle color="primary" formControlName="storbraender">Storbrænder</mat-slide-toggle>
          </div>
          @if (product.text == 'Olie') {
            <div class="form-row">
              <mat-slide-toggle color="primary" formControlName="kondenserende">Kondenserende</mat-slide-toggle>
            </div>
          }
          @if (isStorBraender) {
            <div class="form-row">
              <label class="form-headline">Driftform</label>
              <mat-radio-group formControlName="driftformId">
                @for (driftform of driftformer; track driftform) {
                  <mat-radio-button [value]="driftform.id">
                    {{ driftform.text | titlecase }}
                  </mat-radio-button>
                }
              </mat-radio-group>
            </div>
          }
        </div>
      }
    </form>
  </div>
  <div mat-dialog-actions class="row-reverse">
    <!-- <button *ngIf="!editMode" mat-raised-button color="primary" (click)="save()" [disabled]="anlaegForm.invalid">Tilføj</button> -->
    <button mat-raised-button color="primary" (click)="save()" [disabled]="anlaegForm.invalid">Gem</button>
    <button (click)="cancel()" class="modal-cancel" mat-raised-button>Fortryd</button>
  </div>
